import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";
import { useDispatch } from "react-redux";
import moment from "moment";
import Toast from "../../../../core/components/core/Util/Toast/Toast";

function Form() {
    const profileFilter = chooseProfileFilter()

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();
    const dispatch = useDispatch();
    const { id } = useParams();
    let showToUser = false; 

    dispatch({ type: 'UPDATE_SESSION', key: 'custom_show_modal', value: false });

    const path = '/receivebles/';
    const paths = {
        endpointSave: config.endpoints.backend + 'receivebles/save',
        endpointGetById: config.endpoints.backend + 'receivebles/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllBanks: config.endpoints.backend + 'banks/getall',
        endpointGetAllAgencies: config.endpoints.backend + 'bankagencies/getall',
        endpointGetAllBankAccounts: config.endpoints.backend + 'bankaccounts/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetRelations: config.endpoints.backend + 'bankaccounts/getRelations',
        endpointGetAllResourceSource: config.endpoints.backend + 'resourcesources/getall',
        endpointGetAllDocumentTypesPcontas: config.endpoints.backend + 'documenttypespcontas/getall',
        endpointGetAllPaymentMethods: config.endpoints.backend + 'paymentmethods/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Conta a Receber",
        labelTitleEdit: "Editar Conta a Receber",
        labelTitleView: 'Visualizar Conta a Receber'
    }

    let isInstallment = false;

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            modalOptions: {
                title: 'Atenção!',
                size: 'md',
                showButtons: false,
                content: <div>O valor das parcelas supera o valor total da conta. Se deseja continuar basta fechar este aviso.</div>
            },
            fields: [
                !profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_entity_id: !!values.pdc_entity_id ? values.pdc_entity_id : profileFilter.pdc_entity_id 
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        values.pdc_units = [];
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_project_id: values.pdc_project_id,
                                pdc_bank_account_id: values.pdc_bank_account_id
                            }
                        }
                    },
                    readOnly: true,
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_agency_id',
                    type: 'select',
                    label: 'Agência',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAgencies,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_project_id: values.pdc_project_id,
                                pdc_bank_account_id: values.pdc_bank_account_id
                            }
                        }
                    },
                    readOnly: true,
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_bank_account_id',
                    type: 'select',
                    label: 'Conta Bancária',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAccounts,
                        label: 'accountid',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_project_id: values.pdc_project_id
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        const res = await Fetch.post(paths.endpointGetRelations, {id: values.pdc_bank_account_id})
                        values.pdc_bank_agency_id = '';
                        values.pdc_bank_id= '';

                        if(!!res.pdc_bank_agency_id){
                            values.pdc_bank_id = res.pdc_bank_id;
                            values.pdc_agency_id = res.pdc_bank_agency_id;
                            values.pdc_resource_source_id = res.pdc_resource_source_id;
                        }

                        let form = getForm(values);
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_resource_source_id',
                    type: 'select',
                    label: 'Origem de Recurso',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllResourceSource,
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_project_id: values.pdc_project_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'pdc_document_type_pconta_id',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumentTypesPcontas,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                },
                {
                    name: 'competence_date',
                    type: 'date',
                    label: 'Data de Competencia',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'nfe_number',
                    type: 'text',
                    label: 'Número NFE',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'nfe_serie_number',
                    type: 'text',
                    label: 'Número Série NFE',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'predicted_value',
                    type: 'decimal',
                    label: 'Valor Total',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'issue_date',
                    type: 'date',
                    label: 'Data de Emissão',
                    validations: {
                        required: true
                    },
                    handleChange: async (element,field,values) => {
                        if(!!values.issue_date && !!values.due_date){
                            const verifyDate = moment(values.issue_date).isAfter(values.due_date);
                            if(verifyDate){
                                values.due_date = '';
                                Toast.error('Intervalo de datas errado.');
                            }
                        }
                        let form = getForm(values);
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    columnSize: 6
                },
                {
                    name: 'due_date',
                    type: 'date',
                    label: 'Data de Quitação Total',
                    validations: {
                        required: true
                    },
                    handleChange: async (element,field,values) => {
                        if(!!values.issue_date && !!values.due_date){
                            const verifyDate = moment(values.issue_date).isAfter(values.due_date);
                            if(verifyDate){
                                values.issue_date = '';
                                Toast.error('Intervalo de datas errado.');
                            }
                        }
                        let form = getForm(values);
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    columnSize: 6
                },
                {
                    name: 'isInstallment',
                    type: 'select',
                    label: 'Parcelado',
                    isClearable: true,
                    options: [
                      { label: 'Sim', value: '1' },
                      { label: 'Não', value: '0' }
                    ],
                    handleChange: async (element,field,values) => {
                        isInstallment = values.isInstallment ==='1';
                        values.tranches = null;
                        let form = getForm(values);
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                      required: true
                    },
                    columnSize: 12
                },
                isInstallment && {
                    name: 'tranches',
                    type: 'multiinput',
                    label: 'Parcelas',
                    sortBy: 'index',
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        const totalTranches = form.values.tranches.reduce((sum, item) => {
                            const valueNumber = isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value.replace(/\./g, '').replace(',', '.'));
                            const additionalValue = isNaN(parseFloat(item.additional_value)) ? 0 : parseFloat(item.additional_value.replace(/\./g, '').replace(',', '.'));
                            return (sum + valueNumber + additionalValue);
                        }, 0);
                        const totalValue = isNaN(parseFloat(values.predicted_value)) ? 0 : parseFloat(values.predicted_value);

                        if((totalValue < totalTranches) && !showToUser) {
                            dispatch({ type: 'UPDATE_SESSION', key: 'custom_show_modal', value: true });
                            showToUser = true;
                        }
                    },
                    form: [
                        {
                            label: 'Valor Parcela',
                            type: 'decimal',
                            name: 'value',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Valor Adicional',
                            type: 'decimal',
                            name: 'additional_value',
                            validations: {
                                required: false
                            }
                        },
                        {
                            name: 'pdc_payment_method_id',
                            type: 'select',
                            label: 'Método de Pagamento',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllPaymentMethods,
                                label: 'description',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                }
                            },
                            validations: {
                                required: true
                            },
                            columnSize: 4
                        },
                        {
                            label: 'Data de Vencimento',
                            type: 'date',
                            name: 'due_date',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Status',
                            name: 'status',
                            type: 'select',
                            options: [
                                {
                                    label: "Pago",
                                    value: "Pago"
                                },
                                {
                                    label: "Em Atraso",
                                    value: "Em Atraso"
                                },
                                {
                                    label: "Não Pago",
                                    value: "Não Pago"
                                },
                                {
                                    label: "Pago com Atraso",
                                    value: "Pago com Atraso"
                                }
                            ],
                            validations: {
                                required: true
                            }
                        },
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'textarea',
                    label: 'Descrição',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'files',
                    type: 'multiUploadFileS3',
                    label: 'Anexos',
                    limitFileSize: 20,
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                    uploadFileLimit: 10
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });
                if(!!values.pdc_bank_account_id){
                    const res = await Fetch.post(paths.endpointGetRelations, {id: values.pdc_bank_account_id});
                    if(!!res.pdc_bank_id){
                        values.pdc_bank_agency_id = res.pdc_bank_agency_id;
                        values.pdc_bank_id = res.pdc_bank_id;
                    }
                }
                isInstallment = values.tranches.length > 0;
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
